import React, { Component } from "react";
import { Modal, Table } from "antd";
import $ from "../../../common/AjaxRequest";
import API_URL from "../../../common/url";

class DepartmentGradeLog extends Component {
    state = {
        visible: false,
        loading: false,
        data: [],
        pagination: {
            pageSize: 10,
            current: 1,
            total: 0,
        },
        hospitalDepartmentId: null,
    };

    columns = [
        {
            title: '更新时间',
            dataIndex: 'createTime',
            key: 'createTime',
            width: 160,
        },
        {
            title: '更新人',
            dataIndex: 'createUserName',
            key: 'createUserName',
            width: 100,
        },
        {
            title: '更新字段',
            dataIndex: 'fieldName',
            key: 'fieldName',
            width: 200,
        },
        {
            title: '变更前',
            dataIndex: 'beforeValue',
            key: 'beforeValue',
            width: 200,
            render: (text) => text || '-',
        },
        {
            title: '变更后',
            dataIndex: 'afterValue',
            key: 'afterValue',
            width: 200,
            render: (text) => text || '-',
        },
    ];

    show = (record) => {
        this.setState({
            visible: true,
            hospitalDepartmentId: record.hospitalDepartmentId,
            data: [],
            pagination: { pageSize: 10, current: 1, total: 0 },
        }, () => {
            this.loadData();
        });
    };

    hide = () => {
        this.setState({ visible: false });
    };

    loadData = (page) => {
        const { hospitalDepartmentId, pagination } = this.state;
        if (!hospitalDepartmentId) return;

        const current = page || pagination.current;
        this.setState({ loading: true });
        $.sendRequest({
            method: 'POST',
            url: API_URL.hospital.queryDepartmentModifyLog,
            data: {
                hospitalDepartmentId,
                page: current,
                limit: 10,
            },
            dataType: 'json',
            doneResult: (res) => {
                const list = res.datas || [];
                this.setState({
                    data: list,
                    loading: false,
                    pagination: {
                        ...this.state.pagination,
                        current,
                        total: res.totalCount || list.length,
                    },
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        });
    };

    handleTableChange = (pagination) => {
        this.loadData(pagination.current);
    };

    render() {
        const { visible, loading, data, pagination } = this.state;
        return (
            <Modal
                title="科室档位更新日志"
                visible={visible}
                onCancel={this.hide}
                footer={null}
                className="create-modal"
                wrapClassName="vertical-center-modal"
                maskClosable={false}
                width="1100px"
            >
                <Table
                    columns={this.columns}
                    dataSource={data}
                    rowKey="modifyLogId"
                    loading={loading}
                    pagination={pagination}
                    onChange={this.handleTableChange}
                    size="small"
                    scroll={{ x: 860 }}
                />
            </Modal>
        );
    }
}

export default DepartmentGradeLog;



// WEBPACK FOOTER //
// ./src/components/hospital/departmentInfo/DepartmentGradeLog.js